/**
 * Created by Reda on 21.07.2026
 */

cleverapps.SkinManager.SKINS.testadv_expedition = cleverapps.override(cleverapps.clone(cleverapps.SkinManager.SKINS.adventure_expedition_base, true), {
    bundle: "expedition_testadv",

    slots: {
        gameAudio: function () {
            return bundles.expedition_testadv.urls.testadv_music;
        },

        showOneIngredientLeft: function () {
            return true;
        },

        customerStayFocused: function () {
            return true;
        },

        startQuestsEffect: function () {
            return "quests.start.testadv";
        },

        lockedFogSoundEffect: function () {
            return bundles.extra_sound_effects_testadv.urls.zoom_fog_effect;
        },

        worker_json: bundles.merge_testadv && bundles.merge_testadv.jsons.worker_json
    }
});
